import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'formatDateTime',
})
export class FormatDateTimePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  /**
   * Formats a date with time in the format: "19/06/2025 à 20:30"
   */
  transform(date: Date | undefined): string {
    if (date) {
      const newDate = new Date(date);
      const day = newDate.getDate();
      const month = newDate.getMonth() + 1;
      const year = newDate.getFullYear();
      const hours = newDate.getHours();
      const minutes = newDate.getMinutes();

      const currentLanguage = this.translateService.currentLang;
      const isFrench = currentLanguage === 'fr';

      const formattedDay = day < 10 ? `0${day}` : day;
      const formattedMonth = month < 10 ? `0${month}` : month;
      const formattedHours = hours < 10 ? `0${hours}` : hours;
      const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

      const datePart = isFrench ? `${formattedDay}/${formattedMonth}/${year}` : `${formattedMonth}/${formattedDay}/${year}`;

      const timePart = `${formattedHours}:${formattedMinutes}`;
      const connector = isFrench ? 'à' : 'at';

      return `${datePart} ${connector} ${timePart}`;
    } else {
      return '';
    }
  }
}
